import styled from "styled-components";

export const PageContentWrap = styled.section`
  padding: 2.4rem 2rem 4rem 2rem;
  display: flex;
  justify-content: center;
  min-width: 49rem;
  min-height: 100%;
  cursor: default;

  @media (max-width: 768px) {
    min-width: 0;
    padding: 0;
  }
`;

export const PageLayout = styled.div<{ $width?: string }>`
  width: ${(props) => (props.$width ? props.$width : "70rem")};
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
